import React from "react";
import {StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import {
    FormError,
    FormLabel,
    getInputClassNames,
    getInputWrapperClass,
    getWholeDivWrapperClass,
} from "../../sharedStyles.tsx";
import {defaultParserForSelects} from "../../../dyanimcFormUtil.tsx";


const StaticPercentDisplayRenderer: React.FC<StaticFieldDisplayProps> = ({ component, value, controller }) => {
    const { fieldState } = controller;

    const parsedValue = defaultParserForSelects(value);
    value = parsedValue && parsedValue?.label ? parsedValue.label : value;
    const displayValue = `${value}%`;

    return (
        <div className={getWholeDivWrapperClass(component)}>
            <FormLabel component={component}></FormLabel>
            <div className={getInputWrapperClass(component)}>
                        <span className={getInputClassNames(component, fieldState)}>
                                {displayValue}
                        </span>
            </div>
            <FormError fieldState={fieldState} component={component} />
        </div>
    );
};

export const StaticPercentDisplay = React.memo(StaticPercentDisplayRenderer);